import {
  MASTER_PATIENT_REQUEST,
  MASTER_PATIENT_SUCCESS,
  MASTER_PATIENT_FAILURE,
  PATIENT_REQUEST,
  PATIENT_SUCCESS,
  PATIENT_FAILURE,
  CLAIMS_HISTORY_REQUEST,
  CLAIMS_HISTORY_SUCCESS,
  CLAIMS_HISTORY_FAILURE,
  PATIENT_MEDICAL_CLAIMS_REQUEST,
  PATIENT_MEDICAL_CLAIMS_SUCCESS,
  PATIENT_MEDICAL_CLAIMS_FAILURE,
  PATIENT_RX_CLAIMS_REQUEST,
  PATIENT_RX_CLAIMS_SUCCESS,
  PATIENT_RX_CLAIMS_FAILURE,
  PATIENT_HEALTH_PROFILE_REQUEST,
  PATIENT_HEALTH_PROFILE_SUCCESS,
  PATIENT_HEALTH_PROFILE_FAILURE,
  PATIENT_SURVEY_REQUEST,
  PATIENT_SURVEY_SUCCESS,
  PATIENT_SURVEY_FAILURE,
  PATIENTS_TYPEAHEAD_REQUEST,
  PATIENTS_TYPEAHEAD_SUCCESS,
  PATIENTS_TYPEAHEAD_FAILURE,
  PATIENT_ENCOUNTERS_REQUEST,
  PATIENT_ENCOUNTERS_SUCCESS,
  PATIENT_ENCOUNTERS_FAILURE,
  PATIENTS_ASSIGNMENTTYPES_REQUEST,
  PATIENTS_ASSIGNMENTTYPES_SUCCESS,
  PATIENTS_ASSIGNMENTTYPES_FAILURE,
  PATIENTS_SPECIALPROGRAMS_REQUEST,
  PATIENTS_SPECIALPROGRAMS_SUCCESS,
  PATIENTS_SPECIALPROGRAMS_FAILURE,
  PATIENTSPECIALPROGRAMS_REQUEST,
  PATIENTSPECIALPROGRAMS_SUCCESS,
  PATIENTSPECIALPROGRAMS_FAILURE,
  PATIENTSPECIALPROGRAMS_ASSIGNED_REQUEST,
  PATIENTSPECIALPROGRAMS_ASSIGNED_SUCCESS,
  PATIENTSPECIALPROGRAMS_ASSIGNED_FAILURE,
  PATIENT_DOCUMENTS_REQUEST,
  PATIENT_DOCUMENTS_SUCCESS,
  PATIENT_DOCUMENTS_FAILURE,
  PATIENT_DOCUMENT_UPLOAD_FILES_REQUEST,
  PATIENT_DOCUMENT_UPLOAD_FILES_SUCCESS,
  PATIENT_DOCUMENT_UPLOAD_FILES_FAILURE,
} from './PatientsActions';

const initialState = {
  data: [],
  patient: {},
  history: {},
  medicalClaims: {},
  rxClaims: {},
  encounters: {},
  surveyData: {},
  healthprofile: {},
  typeahead: [],
  error: null,
  isLoading: false,
  isEncountersLoading: false,
  isHistoryLoading: false,
  isHealthProfileLoading: false,
  assignmentTypes: [],
  specialPrograms: [],
  patientSpecialPrograms: [],
  assignedSpecialPrograms: [],
  documents: [],
  isDocumentsLoading: false,
  uploads: {},
  isFilesUploading: false,
  ispatientSpecialProgramsLoading: false
};

export default function patientsReducer(
  state = initialState,
  { type, payload, meta },
) {
  switch (type) {
    case MASTER_PATIENT_REQUEST:
      return { ...state, isLoading: true };
    case MASTER_PATIENT_SUCCESS:
      return { ...state, data: payload.data, patient: {}, error: null, isLoading: false };
    case MASTER_PATIENT_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case PATIENT_REQUEST:
      return { ...state, isLoading: true };
    case PATIENT_SUCCESS:
      return { ...state, patient: payload.data, errors: null, isLoading: false };
    case PATIENT_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case CLAIMS_HISTORY_REQUEST:
      return { ...state, isHistoryLoading: true };
    case CLAIMS_HISTORY_SUCCESS:
      return {
        ...state,
        history: { ...state.history, [meta.patientId]: payload.data },
        error: false,
        isHistoryLoading: false
      };
    case CLAIMS_HISTORY_FAILURE:
      return { ...state, error: payload.error, isHistoryLoading: false };

    case PATIENT_MEDICAL_CLAIMS_REQUEST:
      return { ...state, isLoading: true, };
    case PATIENT_MEDICAL_CLAIMS_SUCCESS:
      return { ...state, medicalClaims: payload.data, error: null, isLoading: false };
    case PATIENT_MEDICAL_CLAIMS_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case PATIENT_RX_CLAIMS_REQUEST:
      return { ...state, isLoading: true, };
    case PATIENT_RX_CLAIMS_SUCCESS:
      return { ...state, rxClaims: payload.data, error: null, isLoading: false };
    case PATIENT_RX_CLAIMS_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case PATIENT_ENCOUNTERS_REQUEST:
      return { ...state, isEncountersLoading: true, };
    case PATIENT_ENCOUNTERS_SUCCESS:
      return {
        ...state,
        encounters: { ...state.encounters, [meta.patientId]: payload.data },
        error: false,
        isEncountersLoading: false
      };
    case PATIENT_ENCOUNTERS_FAILURE:
      return { ...state, error: payload.error, isEncountersLoading: false };

    case PATIENT_SURVEY_REQUEST:
      return { ...state, isLoading: true, };
    case PATIENT_SURVEY_SUCCESS:
      return { ...state, surveyData: payload.data, error: null, isLoading: false };
    case PATIENT_SURVEY_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case PATIENT_HEALTH_PROFILE_REQUEST:
      return { ...state, isHealthProfileLoading: true, };
    case PATIENT_HEALTH_PROFILE_SUCCESS:
      return {
        ...state,
        healthprofile: { ...state.healthprofile, [meta.patientId]: payload.data },
        error: false,
        isHealthProfileLoading: false
      };
    case PATIENT_HEALTH_PROFILE_FAILURE:
      return { ...state, error: payload.error, isHealthProfileLoading: false };

    case PATIENTS_TYPEAHEAD_REQUEST:
      return { ...state, isLoading: true };
    case PATIENTS_TYPEAHEAD_SUCCESS:
      return {
        ...state,
        typeahead: payload.data,
        errors: null,
        isLoading: false,
      };
    case PATIENTS_TYPEAHEAD_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case PATIENTS_ASSIGNMENTTYPES_REQUEST:
      return { ...state, isLoading: true };
    case PATIENTS_ASSIGNMENTTYPES_SUCCESS:
      return {
        ...state,
        assignmentTypes: payload.data,
        errors: null,
        isLoading: false,
      };
    case PATIENTS_ASSIGNMENTTYPES_FAILURE:
      return {
        ...state,
        error: payload.error,
        isLoading: false,
      };

    case PATIENTS_SPECIALPROGRAMS_REQUEST:
      return { ...state, isLoading: true };
    case PATIENTS_SPECIALPROGRAMS_SUCCESS:
      return {
        ...state,
        specialPrograms: payload.data,
        errors: null,
        isLoading: false,
      };
    case PATIENTS_SPECIALPROGRAMS_FAILURE:
      return {
        ...state,
        error: payload.error,
        isLoading: false,
      };

    case PATIENTSPECIALPROGRAMS_REQUEST:
      return { ...state, ispatientSpecialProgramsLoading: true };
    case PATIENTSPECIALPROGRAMS_SUCCESS:
      return {
        ...state,
        patientSpecialPrograms: payload.data,
        error: false,
        ispatientSpecialProgramsLoading: false
      };
    case PATIENTSPECIALPROGRAMS_FAILURE:
      return { ...state, error: payload.error, ispatientSpecialProgramsLoading: false };

    case PATIENTSPECIALPROGRAMS_ASSIGNED_REQUEST:
      return { ...state, ispatientSpecialProgramsLoading: true };
    case PATIENTSPECIALPROGRAMS_ASSIGNED_SUCCESS:
      return {
        ...state,
        assignedSpecialPrograms: payload.data,
        error: false,
        ispatientSpecialProgramsLoading: false
      };
    case PATIENTSPECIALPROGRAMS_ASSIGNED_FAILURE:
      return { ...state, error: payload.error, ispatientSpecialProgramsLoading: false };

    case PATIENT_DOCUMENTS_REQUEST:
      return { ...state, isDocumentsLoading: true };
    case PATIENT_DOCUMENTS_SUCCESS:
      return {
        ...state,
        documents: payload.data,
        error: false,
        isDocumentsLoading: false
      };
    case PATIENT_DOCUMENTS_FAILURE:
      return { ...state, error: payload.error, isDocumentsLoading: false };

    case PATIENT_DOCUMENT_UPLOAD_FILES_REQUEST:
      return { ...state, uploads: {}, isFilesUploading: true };
    case PATIENT_DOCUMENT_UPLOAD_FILES_SUCCESS:
      return {
        ...state,
        uploads: payload.data,
        errors: null,
        isFilesUploading: false,
      };
    case PATIENT_DOCUMENT_UPLOAD_FILES_FAILURE:
      return {
        ...state,
        error: payload.error,
        isFilesUploading: false,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/patients/PatientsReducer.js